import CodeView from 'src/components/CodeView';
import gridBasic from 'src/examples/BlockLayout/gridBasic';
import applicationGrid from 'src/examples/BlockLayout/applicationGrid';
import flexBasic from 'src/examples/BlockLayout/flexBasic';
import applicationFlex from 'src/examples/BlockLayout/applicationFlex';
import flexExample2 from 'src/examples/BlockLayout/flexExample2.1';
import flexExample22 from 'src/examples/BlockLayout/flexExample2.2';
import * as React from 'react';
export default {
  CodeView,
  gridBasic,
  applicationGrid,
  flexBasic,
  applicationFlex,
  flexExample2,
  flexExample22,
  React
};